import { IStatusData } from '@/providers/StatusDataProvider';
import { createContext } from 'react';

const StatusDataContext = createContext<{ data: IStatusData | null; loading: boolean; error: string | null }>(null);

export default StatusDataContext;
